import BpmnModeler from "bpmn-js/lib/Modeler";

import CliModule from "bpmn-js-cli";
// 自定义模块
import CustomModule from "../config";

import flowableModdleDescriptor from "../config/flowable";


export const initBpmnModeler = container => {
  let bpmnModeler = new BpmnModeler({
    // 容器
    container: container,
    // 模块
    additionalModules: [CliModule, CustomModule],
    cli: { bindTo: "cli" },
    bpmnRenderer: {
      // defaultFillColor: '#fff',
      // defaultStrokeColor: '#6CB139',
    },
    moddleExtensions: {
      flowable: flowableModdleDescriptor
    }
  });

  return bpmnModeler;
};
